import { Navigate } from "react-router-dom";

export default function QualityReportRedirect() {
  return <Navigate to="/reports/quality/trend" replace />;
}
